import { render, staticRenderFns } from "./TuitionPage.vue?vue&type=template&id=3b6677fa&scoped=true&"
import script from "./TuitionPage.vue?vue&type=script&lang=js&"
export * from "./TuitionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6677fa",
  null
  
)

export default component.exports